import { render, staticRenderFns } from "./ejwdList.vue?vue&type=template&id=15d2b3f4&scoped=true&"
import script from "./ejwdList.vue?vue&type=script&lang=js&"
export * from "./ejwdList.vue?vue&type=script&lang=js&"
import style0 from "./ejwdList.vue?vue&type=style&index=0&id=15d2b3f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d2b3f4",
  null
  
)

export default component.exports